import script from "./IsMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./IsMobile.vue?vue&type=script&setup=true&lang=js"

import "./IsMobile.vue?vue&type=style&index=0&id=8ab9a87c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ab9a87c"]])

export default __exports__